var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.505127 12.0049V1.00488C0.505127 0.72874 0.728985 0.504883 1.00513 0.504883C1.28127 0.504883 1.50513 0.728741 1.50513 1.00488V12.0049C1.50513 12.281 1.28127 12.5049 1.00513 12.5049C0.728985 12.5049 0.505127 12.281 0.505127 12.0049ZM11.0051 4.50488V4.50488C10.9981 4.72961 10.8754 4.93473 10.6807 5.04718C8.01395 6.55746 5.34728 6.50968 2.68065 7.88901C2.62557 7.91757 2.56634 7.93728 2.50513 7.94741C2.40852 7.96472 2.30891 7.95132 2.2203 7.90911C2.08278 7.8388 1.99875 7.69488 2.00513 7.54056C2.01284 7.27918 2.15591 7.04061 2.38285 6.91071C2.4236 6.88796 2.46436 6.86555 2.50513 6.84348V1.96813C2.46434 1.95923 2.42359 1.95071 2.38285 1.94256C2.1563 1.90145 1.99496 1.69928 2.00513 1.46926V1.46926C2.00999 1.29183 2.08784 1.12428 2.2203 1.00613C2.29963 0.932433 2.39852 0.88315 2.50513 0.864183C2.56345 0.854459 2.62312 0.856481 2.68065 0.870133C5.3474 1.51468 8.01395 3.58613 10.6807 4.09968C10.8753 4.13401 11.0142 4.30747 11.0051 4.50488H11.0051Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalFlag);
export default __webpack_public_path__ + "static/media/signalFlag.c4b408bcbd81987c94d774363ba2dbda.svg";
export { ForwardRef as ReactComponent };